import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import CLabelCard from '../../../Assets/Components/CLabelCard';
import CCard from '../../../Assets/Components/CCard';
import { Button, Col, Row, Form as FormANTD } from 'antd';
import Table from '../../../Assets/Components/CTable';
import CIcon from '../../../Assets/Components/CIcon';
import { Field, Form } from 'react-final-form';
import { InputDatePicker } from '../../../Assets/Components/CInputDate';
import moment from 'moment';

interface IProps {
  columnData: any;
  dataLeads: any[];
  handleSearch: (values: any) => void;
  intl: IntlShape;
  isLoading: boolean;
}

function LeadsComponent(props: IProps) {
  const { columnData, dataLeads, isLoading, handleSearch } = props;
  const defaultDate = [moment().startOf('month'), moment()];

  const LeadsCardContent = () => {
    return (
      <div className="containerWhiteZurich">
        <Form onSubmit={() => {}}>
          {formProps => {
            const { values } = formProps;

            return (
              <FormANTD>
                <Row gutter={20}>
                  <div className="divCheckbox">
                    <label className="labelBtnFilter marginBottom8">
                      Tanggal
                    </label>
                    <Field
                      name="date"
                      component={InputDatePicker}
                      defaultValue={defaultDate}
                      idComponent="inputDateFilterListLicense"
                      typeDate="dateRangePicker"
                      placeholder={['Tanggal Mulai', 'Tanggal Berakhir']}
                    />
                  </div>
                  <Col span={6} className={'btnFilterAplicationList'}>
                    <Button
                      type="primary"
                      icon={<CIcon type="SearchOutlined" />}
                      onClick={() => handleSearch(values)}
                      id="btnSearch"
                      className="spacingBtnSecondRow2 btnRadius10 btnFeedbackBank"
                      loading={isLoading}
                    >
                      Cari
                    </Button>
                  </Col>
                </Row>
              </FormANTD>
            );
          }}
        </Form>
        <Table
          columns={columnData}
          pagination={true}
          data={dataLeads}
          useFilterGlobal
          isLoading={isLoading}
        />
      </div>
    );
  };

  return (
    <>
      <CLabelCard leftText="Delete Leads" />
      <CCard
        cardClassName="cardStyleZurich"
        cardTitle={<span className="titleCardStyleZurich">Daftar Leads</span>}
        cardContent={LeadsCardContent()}
      />
    </>
  );
}

export default injectIntl(LeadsComponent);
